import React from 'react';
import { useModal } from '../../../../helpers/hooks/modalContext';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
import styles from './PadTerms.module.css';

const PadTerms: React.FC = () => {
  const { setModal, modalState } = useModal();
  const termsContent = modalState?.padTermsContent || '';

  return (
    <motion.main
      className={styles.main}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className={styles.headingOuter}>
        <div className='flex items-center gap-[12px]'>
          <span>Pre-authorized debit agreement</span>
        </div>
        <X
          className={styles.crossIcon}
          size={24}
          onClick={() => setModal(null)}
          stroke='#0E0E0B'
        />
      </div>

      <div className={styles.contentOuter}>
        <div
          className={styles.termsContent}
          dangerouslySetInnerHTML={{ __html: termsContent }}
        />
      </div>

      <div className={styles.buttonOuter}>
        <button
          className={styles.closeButton}
          onClick={() => setModal(null)}
        >
          Close
        </button>
      </div>
    </motion.main>
  );
};

export default PadTerms;

